import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import config from '../config/config.js';
import Loader from "../components/Loader/Loader.jsx";
import GlobalLoader from "../components/Loader/GlobalLoader.jsx";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute.jsx";

const LayoutPrivadas = lazy(() => import("../layouts/LayoutPrivadas/LayoutPrivadas.jsx"));
const Home = lazy(() => import("../pages/Home/Home.jsx"));
const Index = lazy(() => import("../pages/Index/Index.jsx"));
const Evaluador = lazy(() => import("../pages/Evaluador/Evaluador.jsx"));
const Evaluado = lazy(() => import("../pages/Evaluado/Evaluado.jsx"));
const Seguimientos = lazy(() => import("../pages/Seguimientos/Seguimientos.jsx"));
const Jerarquias = lazy(() => import("../pages/Jerarquias/Jerarquias.jsx"));
const ObjetivosOrganizacionales = lazy(() => import("../pages/ObjetivosOrganizacionales/ObjetivosOrganizacionales.jsx"));
const Nomina = lazy(() => import("../pages/Nomina/Nomina.jsx"));
const Login = lazy(() => import("../pages/Login/Login.jsx"));
const Evaluacion = lazy(() => import("../pages/Evaluacion/Evaluacion.jsx"));
const Conversaciones = lazy(() => import("../pages/Conversaciones/Conversaciones.jsx"));
const Auditoria = lazy(() => import("../pages/Auditoria/Auditoria.jsx"));
const AuditoriaEvaluador = lazy(() => import("../pages/Auditoria/AuditoriaEvaluador.jsx"));
const Graficos = lazy(() => import("../pages/Graficos/Graficos.jsx"));
const Calificacion = lazy(() => import("../pages/Calificacion/Calificacion.jsx"));
const Reporte = lazy(() => import("../pages/Reporte/Reporte.jsx"));
const Steps = lazy(() => import("../pages/Steps/Steps.jsx"));
const OlvideContraseña = lazy(() => import("../pages/OlvideContraseña/OlvideContraseña.jsx"));
const RestablecerContraseña = lazy(() => import("../pages/RestablecerContraseña/RestablecerContraseña.jsx"));
const ListadoCalificaciones = lazy(() => import("../pages/ListadoCalificaciones/ListadoCalificaciones.jsx"));
const ActivateAccount = lazy(() => import("../pages/ActivateAccount/ActivateAccount.jsx"));
const Perfil = lazy(() => import("../pages/Perfil/Perfil.jsx"));
const Configuracion = lazy(() => import("../pages/Configuracion/Configuracion.jsx"));
const JerarquiasUsuario = lazy(() => import("../pages/Configuracion/JerarquiasUsuario.jsx"));
const GruposPermisos = lazy(() => import("../pages/Configuracion/GruposPermisos.jsx"));
const NotFound = lazy(() => import("../pages/NotFound/NotFound.jsx"));
const PlantillasObjetivos = lazy(() => import("../pages/PlantillasObjetivos/PlantillasObjetivos.jsx"));

export const privateRoutes = [
  { path: "/", element: <Home /> },
  { path: "/index", element: <Index /> },
  { path: "/evaluador", element: <Evaluador /> },
  { path: "/evaluado", element: <Evaluado /> },
  
  { path: "/evaluacion", element: <Evaluacion /> },
  
  { path: "/conversaciones", element: <Conversaciones /> },
  
  { path: "/calificaciones", element: <Calificacion /> },
  { path: "/listado-calificaciones", element: <ListadoCalificaciones /> },
  { path: "/reporte-general", element: <Reporte /> },
  { path: "/graficos", element: <Graficos /> },
  
  { path: "/auditoria", element: <Auditoria /> },
  { path: "/auditoria-evaluador", element: <AuditoriaEvaluador /> },
  { path: "/nomina-evaluados", element: <Nomina /> },
  { path: "/jerarquias", element: <Jerarquias /> },
  { path: "/principios-culturales", element: <ObjetivosOrganizacionales /> },
  { path: "/seguimientos", element: <Seguimientos /> },
  { path: "/steps", element: <Steps /> },
  { path: "/perfil", element: <Perfil /> },
  { path: "/configuracion", element: <Configuracion /> },
  { path: "/configuracion/jerarquias-usuario", element: <JerarquiasUsuario /> },
  { path: "/configuracion/grupos-permisos", element: <GruposPermisos /> },
  { path: "/test", element: <Login /> },
];

export default function Rutas() {
  return (
    <BrowserRouter basename={config.URL.BASENAME}>
      <GlobalLoader />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/restablecer-contraseña" element={<OlvideContraseña />} />
          <Route path="/password-reset/:token" element={<RestablecerContraseña />} />
          <Route path="/activate-account/:token" element={<ActivateAccount />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/IA" element={<PlantillasObjetivos />} />

          <Route element={<LayoutPrivadas />}>
            {privateRoutes.map(({ path, element }, i) => (
              <Route 
                key={i} 
                path={path} 
                element={
                  <ProtectedRoute>
                    {element}
                  </ProtectedRoute>
                } 
              />
            ))}
          </Route>
        </Routes>
      </Suspense>

      <ToastContainer 
        position="top-right" 
        autoClose={3000} 
        hideProgressBar={false} 
        newestOnTop={false} 
        closeOnClick 
        rtl={false} 
        pauseOnFocusLoss 
        draggable 
        pauseOnHover 
      />
    </BrowserRouter>
  );
}